import React from "react";
import "./DeleteConfirmModal.css";

const InactiveEditModal = ({ isOpen, onClose, partnerName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-admin">
        <div className="modal-header">
          <h6>Cannot Edit Inactive Partner</h6>
        </div>
        <div className="modal-body p-2">
          <p>
            You cannot edit <strong>{partnerName}</strong> because it is currently inactive.
          </p>
          <p>
            Please activate this OEM partner first to make changes.
          </p>
        </div>
        <div className="modal-footer">
          <button className="delete-btn" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactiveEditModal;